import { BaseXHR } from 'utils/axios';
import { addTicketType } from 'utils/helper';

export const getInventoryApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/cart/get-inventory', addTicketType(data));

export const updateOrderApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/update-order', addTicketType(data));

export const checkInventoryApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/cart/check-inventory', addTicketType(data));

export const getApprovalOrderListApi = params =>
  BaseXHR.$get('b2b/v1/order/list-approval', params);

export const approvalOrderApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/approve-payment', data);

export const adjustOrder = (data: FormData) =>
  BaseXHR.$post('b2b/v1/checkout/adjust-order', data);

export const sendMailToPartner = (data: FormData) =>
  BaseXHR.$post('mail/send-by-order', data);

//Danh sách đơn hàng combo holiday
export const getListOrderApi = params =>
  BaseXHR.$get('b2b/holiday/order/listing', params);
//xuất danh sách excel theo điều kiện cho danh sách đơn hàng combo holiday
export const exportListOrderExcelApi = payload => {
  const newParam = new URLSearchParams(payload);
  return BaseXHR.$get('b2b/holiday/order/export?', newParam);
};
//Hủy thanh toán danh sách đơn hàng combo holiday
export const cancelOrderComboHolidayApi = (data: any) =>
  BaseXHR.$post('b2b/holiday/order/cancel', data);
//Hủy thanh toán danh sách đơn hàng combo holiday
export const checkoutPaymentOrderComboHolidayApi = (data: any) =>
  BaseXHR.$post('b2b/v1/checkout/payment', data);
//Laayss danh sách thanh toán theo từng account
export const getLOVpaymentMethod = () =>
  BaseXHR.$get('b2b/holiday/common/list-payments');
